export default {"src":"/_next/static/media/th.5f5515bc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};